import {FuseRouteItemType} from '@fuse/utils/FuseUtils';

import {AUTH_ROLES} from '@/app/auth/authRoles';

import ResetPasswordPage from './ResetPasswordPage';

const ResetPasswordRoute: FuseRouteItemType = {
  path: 'password/forgot',
  element: <ResetPasswordPage />,
  auth: AUTH_ROLES.onlyGuest, // []
};

export default ResetPasswordRoute;
